<template>
<div>
  <v-dialog v-model="isVisible" width="500" scrollable>
    <v-card>
      <v-card-title class="headline lighten-2" primary-title> </v-card-title>
      <v-card-text v-if="freeTime">
        <template>
          <v-container style="padding: 26px 0 0;">
            <!-- <div class="dialog-subtitle">Clique para alterar</div> -->
            <v-row>
              <v-col cols="12" style="padding: 0;" class="text-center">
                <v-text-field
                  readonly
                  :value="scheduledDate"
                  label=""
                  :hint="scheduledWeekDate"
                  persistent-hint
                  class="big-purple-date-picker"
                  style="max-width: 180px; margin: 0 auto;"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <div class="text-center">
          <v-text-field
          class="big-purple-time-picker"
          append-icon="   "
          hide-details=""
          flat
          solo=""
          editable
          readonly=""
          item-value="text"
          :value="`${freeTime.start_at} h`"
          text-center
          style="max-width: 150px; margin: 0 auto; text-weight: 900;"
        />
        </div>
        
        <v-divider></v-divider>

        <p class="dialog-subtitle">
          <br />
          Status deste horário
          <br />
          <span
            style="font-size: 26px; color: #440099; font-weight: 900; line-height: 1.5;"
          >
            <template v-if="isAllocated">
              Aula marcada
            </template>
            <template v-else-if="isCanceled">
              Aula cancelada
            </template>
            <template v-else-if="freeTime && freeTime.freeTime">
              Disponível
            </template>
            <template v-else>
              Disponível
            </template>
          </span>
          <br /><br />
          <span
            v-if="scheduledClass && (isAllocated || isCanceled)"
            style="font-weight: 400; text-transform: none; font-size: 16px;"
            >Aluno: {{ scheduledClass ? scheduledClass.student_profile.name : 'HORARIO DESMARCADO' }} <br />Assunto:
            {{ scheduledClass.description }}
          </span>
          <br /><br /><br />

          <div v-if="scheduledClass && scheduledClass.location">
            <p
            class="px-12 text-center mb-1"
            style="font-weight: 900; color: #440099; font-size: 21px;">HOME SCHOOL
            </p>
            <p
             class="px-12 text-center address-text"
            style="opacity: 0.8; text-transform: capitalize;">
              {{ scheduledClass.location }}
              <v-btn v-if="false" rounded color="primary" depressed class="mt-2" >Abrir no Google Maps</v-btn>
            </p>
          </div>



        <div style="margin: 30px auto; ">
          <v-btn
            v-if="isAllocated"
            @click="unscheduleClassClick"
            depressed
            large
            block
            outlined
            rounded
            color="#FF6D00"
            class="mb-5"
            >Desmarcar esta aula</v-btn
          >
          <v-btn
            v-if="!isAllocated"
            @click="allocateFreeTime"
            depressed
            large
            block
            outlined
            rounded
            color="primary"
            class="mb-5"
            >Tornar horário indisponível</v-btn
          >
          <v-btn
            v-if="false"
            depressed
            large
            block
            outlined
            rounded
            color="primary"
            class="mb-5"
            >Tornar dia indisponível</v-btn
          >
          <v-btn
            v-if="false"
            depressed
            large
            block
            outlined
            rounded
            color="primary"
            class="mb-5"
            disabled
            >Tornar horário disponível</v-btn
          >
          <v-btn
            v-if="false"
            depressed
            large
            block
            outlined
            rounded
            color="primary"
            class="mb-5"
            disabled
            >Tornar dia disponível</v-btn
          >
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="grey" rounded outlined @click="close">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog :value="confimUnschedule" persistent  max-width="460" transition="fade">
    <v-card>
      <v-card-title class="headline"></v-card-title>

      <v-card-text v-if="userProfile">

        <div class="schedule-confirmation-dialog-text mx-5" v-if="!less_than_24">
          <b>TEM CERTEZA QUE DESEJA<BR />DESMARCAR ESTA AULA?</b>
          <br /><br />
          <v-icon>mdi-information-outline</v-icon>
          <br />Você já desmarcou {{ (userProfile.user.cancel_count + 0) }} aula neste semestre, ainda pode desmarcar 
          {{ quantityCanceled }} (sem ser penalizado pelo CEM).
          <br />
        </div>

        <div class="schedule-confirmation-dialog-text mx-5" v-if="less_than_24">
          <b>TEM CERTEZA QUE DESEJA<BR />DESMARCAR ESTA AULA?</b>
          <br /><br />
          <v-icon>mdi-information-outline</v-icon>
          <br />

          <p> <strong style="color:#FF3d00"> Você será penalizado </strong> pois sua aula começaria dentro de 24h. </p>
          <br />
        </div>

        <div class="text-center">
          <v-btn
          @click="confirmUnschedule"
          color="#FF3d00"
          class="px-5 mt-3 mb-12"
          rounded
          :loading="loading"
          depressed
          outlined
        >
          {{ this.scheduledClass ? 'Desmarcar aula' : 'Tornar Disponível'}}
        </v-btn>
        <br/>

        <v-btn
          color="primary"
          class="px-5 mt-5"
          rounded
          depressed
          @click="confimUnschedule = false"
        >
          Voltar
        </v-btn>
        </div>
      </v-card-text>

    </v-card>
  </v-dialog>

</div>
</template>

<script>
import ProfessorsRepository from "@/repositories/ProfessorsRepository";
import ConfimrUnscheduleClass from "@/components/dialogs/ConfirmUnscheduleClass";

import { mapState } from 'vuex'

export default {
  components: {
    ConfimrUnscheduleClass
  },
  props: {
    visibility: Boolean,
    dateFormatted: [String, Date],
    date: [String, Date]
  },
  data() {
    return {
      modal: undefined,
      confimUnschedule: false,
      isVisible: this.visibility,
      scheduledClass: undefined,
      freeTime: undefined,
      isAllocated: undefined,
      isCanceled: undefined,
      scheduledDate: undefined,
      scheduledDateObj: undefined,
      scheduledWeekDate: undefined,
      less_than_24: false,
      dropdown_edit: [
        { text: "10:00" },
        { text: "11:00" },
        { text: "12:00" },
        { text: "13:00" },
        { text: "14:00" },
        { text: "15:00" },
        { text: "16:00" },
        { text: "17:00" },
        { text: "18:00" },
        { text: "19:00" }
      ],
      loading: false
    };
  },

  computed: {
    ...mapState(['userProfile']),

    quantityCanceled() {
      if (this.userProfile.user.cancel_count <= 3 ) {
        return -1 * (this.userProfile.user.cancel_count - 3)

      } else {
        return 0
      }
    }
  },

  watch: {
    visibility: {
      immediate: true,
      handler(visibility) {
        this.isVisible = visibility;
      }
    },
    isVisible: {
      handler(visibility) {
        visibility ? this.$emit("open") : this.$emit("close");
      }
    }
  },
  methods: {
    async unscheduleClassClick() {

      if (this.scheduledClass) {
        this.confimUnschedule = true

        let response = {}
        response = await ProfessorsRepository.verify_24_class(this.scheduledClass.id, this.scheduledClass.student_id)
        if ( response.data.less_than_24 ) {
          this.less_than_24 = true
        } else {
          this.less_than_24 = false
        }

      } else {
        this.unscheduleClass()
      }
    },

    open(teacherDialogObject) {
      this.freeTime = teacherDialogObject.freeTime.freeTime;
      this.isCanceled = teacherDialogObject.isCanceled;
      this.isAllocated = teacherDialogObject.isAllocated;

      this.scheduledDate = teacherDialogObject.date.toLocaleDateString("pt-BR");
      this.scheduledDateObj = teacherDialogObject.date;
      this.scheduledClass = teacherDialogObject.allocatedClass;
      this.scheduledWeekDate = teacherDialogObject.date.toLocaleDateString("pt-BR", {weekday: 'long' });

      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
      this.$emit("close");
    },
    async allocateFreeTime() {
      const response = await ProfessorsRepository.allocateFreeTime(this.freeTime.id, this.scheduledDateObj.toISOString().substring(0, 10))
      this.$router.go()

    },

    async unscheduleClass() {

      if (this.scheduledClass) {
        const result = await ProfessorsRepository.unscheduleClass(
          this.scheduledClass.id
        );
        if ( result.status == 200 ) this.$router.go()

      } else {
        const result = await ProfessorsRepository.removeAllocation(
          this.freeTime.id, this.scheduledDateObj.toISOString().substring(0, 10)
        );
      }

      this.$router.go()
    },

    confirmUnschedule() {
      this.loading = true;
      this.unscheduleClass()
    }

  }
};
</script>

<style scoped>
.address-text{
  -moz-user-select: text;
  -khtml-user-select: text;
  -webkit-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
/* estilo do dialog */
.dialog-subtitle {
  text-align: center;
  color: #a09aab;
  font-weight: 400;
  font-size: 13px;
  /* margin: 0 auto 18px; */
  text-transform: uppercase;
}
/* sobreescrevendo date picker */
.big-purple-date-picker.theme--light.v-text-field.v-text-field--is-booted
  >>> input {
  text-align: center;
  color: #440099;
  font-size: 26px;
  /* max-width: 200px; */
  font-weight: 900;
  margin: 0 auto;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
}
.big-purple-date-picker.theme--light.v-text-field >>> .v-input__slot::before {
  border-top: none;
}
.big-purple-date-picker.theme--light.v-text-field >>> .v-input__slot {
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  margin: 0;
}
.big-purple-date-picker >>> .theme--light.v-messages {
  margin: 0;
  color: #a09aab;
  text-transform: uppercase;
}
div.big-purple-date-picker >>> div.v-text-field__details {
  text-align: center;
  /* display: none; */
}
/* sobreescrevendo time picker */
.v-input.big-purple-time-picker >>> .v-input__slot {
  /* height: 40px; */
  margin-bottom: 30px;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
}
.v-input.big-purple-time-picker >>> input {
  text-align: right;
  color: #440099;
  font-size: 26px;
  max-width: 200px;
  font-weight: 900;
  margin: 0 auto;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
}
div.big-purple-time-picker.v-input.big-purple-time-picker.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted.v-select.v-autocomplete.v-overflow-btn.v-overflow-btn--editable
  >>> ::before,
div.big-purple-date-picker
  >>> i.v-icon.notranslate.mdi.mdi-menu-down.theme--light {
  background-color: rgba(0, 0, 0, 0) !important;
  /* background-color: transparent; */
  border: none;
  color: #440099;
  transform: scale(2);
  max-width: 150px;
  text-align: right;
  margin: 0 auto;
}
/* div.big-purple-time-picker.v-input.big-purple-time-picker.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted.v-select.v-autocomplete.v-overflow-btn.v-overflow-btn--editable
  >>> .v-input__slot::before {
  max-width: 100px;
  margin: 0 auto;
  text-align: center;
} */
</style>


<style>

.schedule-confirmation-dialog-text {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: rgba(45, 35, 58, 0.5);
  line-height: 1.4;
}
.schedule-confirmation-dialog-text span {
  font-size: 21px;
  font-weight: 900;
  color: #440099;
  text-transform: uppercase;
}
</style>